<div class="container">

<h2>Backend is not available</h2>

<p>Backend is currently not available. <i>Das Backend ist aktuell nicht erreichbar.</i></p>

<p><a routerLink="/login">Go to start page.</a>&nbsp;<i><a routerLink="/login">Zur Startseite wechseln.</a></i></p>

</div>